// @flow
import React, { useEffect, useState } from 'react';

import ClubSearch from 'components/club/ClubSearch';
import type { FullUserType } from 'types/User';
import { dynamicClassName } from 'utils/dynamicClassName';

export type StateProps = { userPref: FullUserType };

type Props = StateProps & {
  isMobile?: boolean
};

function HeaderSearch({ isMobile, userPref }: Props) {
  const [clubSearchInputFocused, setClubSearchInputFocused] = useState(false);
  const [geolocalisation, setGeolocalisation] = useState(false);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setGeolocalisation(true);
      }),
        error => {
          console.warn(`ERREUR (${error.code}): ${error.message}`);
          setGeolocalisation(false);
        };
    } else {
      setGeolocalisation(false);
    }
  }, []);

  const handleInputClubSearchClicked = () => {
    setClubSearchInputFocused(true);
  };

  const handleClickOutsideClubSearch = () => {
    setClubSearchInputFocused(false);
  };

  const clubSearchclassNamesInput = dynamicClassName('search-club');
  clubSearchInputFocused && clubSearchclassNamesInput.add('has-autocompletion');
  isMobile && clubSearchclassNamesInput.add('mobile-tablet-only');
  !isMobile && clubSearchclassNamesInput.add('display-1080');

  return (
    <div className={clubSearchclassNamesInput.build()}>
      <ClubSearch
        handleInputClicked={handleInputClubSearchClicked}
        handleClickOutside={handleClickOutsideClubSearch}
        customPlaceholder={geolocalisation ? 'Ma position' : 'Rechercher un club (nom, ville, adresse...)'}
        targetBlank
        geolocLink={`/trouver-un-club-de-rugby/resultats-de-recherche/?autour=${geolocalisation ? 'true' : 'false'}`}
        // ffrDomain="https://www.ffr.fr" // !ne fonctionne pas avec le link mais devrait fonctionner avec les params d'url
        geolocalisation={geolocalisation}
        userPref={userPref}
      />
    </div>
  );
}

export default HeaderSearch;
